import React from "react";
import { Button } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkIcon from "@mui/icons-material/Link";
import { getMessage, useLocale } from "../i18n/locale";
import { normalizeWebsiteUrl } from "../services/websiteUrl";

export default function StudioExternalLinks({ studio }) {
  const locale = useLocale();
  const siteUrl = normalizeWebsiteUrl(studio.siteUrl);
  const hostname = siteUrl ? new URL(siteUrl).hostname.toLowerCase() : "";
  const isFacebook = hostname === "facebook.com" || hostname.endsWith(".facebook.com")
    || hostname === "fb.com" || hostname.endsWith(".fb.com");
  const facebookUrl = normalizeWebsiteUrl(studio.links?.facebook) || (isFacebook ? siteUrl : "");

  return <>
    {siteUrl && !isFacebook && (
      <Button size="small" variant="outlined" startIcon={<LinkIcon />}
        href={siteUrl} target="_blank" rel="noopener noreferrer">
        {getMessage(locale.locale, "signupWebsite")}
      </Button>
    )}
    {facebookUrl && (
      <Button size="small" variant="outlined" startIcon={<FacebookIcon />}
        href={facebookUrl} target="_blank" rel="noopener noreferrer">
        {getMessage(locale.locale, "eventViewOnFacebook")}
      </Button>
    )}
  </>;
}
